export const LUMINA_APP_VERSION = 1;
